<div class="modal-body">
    <div class="modal-text-wrapper">
        <p>{{information}}</p>
    </div>
</div>